/**
 * Shared page chrome — flat toolbar + dense sections (no nested page Card).
 */
import React from "react";
import { Space, Typography } from "antd";

const { Title, Text } = Typography;

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  extra?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  extra,
}) => (
  <div className="page-header">
    <div>
      <Title level={4} className="page-title">
        {title}
      </Title>
      {subtitle ? (
        <Text type="secondary" className="page-subtitle">
          {subtitle}
        </Text>
      ) : null}
    </div>
    {extra ? <Space size={8} wrap>{extra}</Space> : null}
  </div>
);

export default PageHeader;
